export default "__VITE_IMAGE_ASSET__9ea42836__";